import alefRegularUrl from '../../../fonts/Alef/Alef-Regular.ttf';
import alefBoldUrl from '../../../fonts/Alef/Alef-Bold.ttf';

let fontsPromise = null;

function fetchFontAsBase64(url) {
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch font: ${response.status}`);
      }
      return response.arrayBuffer();
    })
    .then((buffer) => {
      const bytes = new Uint8Array(buffer);
      let binary = '';
      const chunkSize = 0x8000;
      for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
      }
      return btoa(binary);
    });
}

// Registers the Alef font (Hebrew + Latin, SIL OFL) on a jsPDF document.
// jsPDF standard fonts have no Hebrew glyphs, so without this Hebrew text
// comes out as garbage characters in exported reports.
export function registerHebrewPdfFont(doc) {
  if (!fontsPromise) {
    fontsPromise = Promise.all([
      fetchFontAsBase64(alefRegularUrl),
      fetchFontAsBase64(alefBoldUrl),
    ]).catch((err) => {
      fontsPromise = null;
      throw err;
    });
  }
  return fontsPromise.then(([regular, bold]) => {
    doc.addFileToVFS('Alef-Regular.ttf', regular);
    doc.addFont('Alef-Regular.ttf', 'Alef', 'normal');
    doc.addFileToVFS('Alef-Bold.ttf', bold);
    doc.addFont('Alef-Bold.ttf', 'Alef', 'bold');
  });
}

// jsPDF's bidi hook assumes text is already in visual order, which draws
// logical Hebrew mirrored and flips embedded numbers. These options make it
// run the full Unicode bidi algorithm (logical -> LTR visual) instead.
// Latin-only text passes through unchanged.
const RTL_TEXT_OPTIONS = {
  isInputVisual: false,
  isOutputVisual: true,
  isOutputRtl: false,
};

// Wraps doc.text so every call (including jspdf-autotable's internal ones,
// which pass no options) renders Hebrew correctly. Call once per document.
export function applyPdfRtlSupport(doc) {
  const originalText = doc.text.bind(doc);
  doc.text = (text, x, y, options, ...rest) =>
    originalText(text, x, y, { ...RTL_TEXT_OPTIONS, ...(options || {}) }, ...rest);
}
